<template>
  <div>
         <el-row :gutter="10">
                <el-col :span="10">
                  <el-input
                    clearable
                    v-model="aprItemObject.catalogName"
                    placeholder="请输入追差项分类名称"
                  ></el-input
                ></el-col>
                <el-col :span="10">
                  <el-input
                    clearable
                    v-model="aprItemObject.itemName"
                    placeholder="请输入追差项名称"
                    ></el-input>
                </el-col>
             
           <el-col :span="4">
            <el-button
                  style="margin-left:5px"
                  icon="el-icon-delete"
                  @click="deleteAprItem()"
                ></el-button>
           </el-col>
         </el-row>
  </div>
</template>

<script>
export default {
  name: "aprItem",
  components: {},
  props: [
    "aprItemObject",
    "itemIndex",
  ],
  data() {
    return {
    };
  },
  watch: {
  },
  computed: {},
  methods: {
    deleteAprItem(){
       this.$emit(
        "deleteAprItem",
        this.$props.itemIndex
      );
    },
  },
  created() {},
  mounted() {
  },
};
</script>
<style lang="less" scoped></style>
